import {
  SENDING_EMAIL,
  SEND_EMAIL_ERROR,
  SEND_EMAIL_SUCCESS,
  EMAIL_VERIFIED,
} from '../actions';

export const initialState = {
  emailSent: false,
  emailVerified: false,
  error: false,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SENDING_EMAIL: {
      return { ...initialState };
    }
    case SEND_EMAIL_SUCCESS: {
      return {
        ...state,
        emailSent: true,
        error: initialState.error,
      };
    }
    case SEND_EMAIL_ERROR: {
      return {
        ...state,
        emailSent: initialState.emailSent,
        error: action.error,
      };
    }
    case EMAIL_VERIFIED: {
      return {
        ...state,
        emailVerified: true,
        emailSent: initialState.emailSent,
        error: initialState.error,
      };
    }
    default:
      return state;
  }
}

export default reducer;
